// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27rgba%280,0,0,.5%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M5 14l6-6-6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    min-height: 100vh;
    min-height: -webkit-fill-available;
  }
  
  html {
    height: -webkit-fill-available;
  }
  
  main {
    display: flex;
    flex-wrap: nowrap;
    height: 100vh;
    height: -webkit-fill-available;
    max-height: 100vh;
    overflow-x: auto;
    overflow-y: hidden;
  }
  
  .b-example-divider {
    flex-shrink: 0;
    width: 1.5rem;
    height: 100vh;
    background-color: rgba(0, 0, 0, .1);
    border: solid rgba(0, 0, 0, .15);
    border-width: 1px 0;
    box-shadow: inset 0 .5em 1.5em rgba(0, 0, 0, .1), inset 0 .125em .5em rgba(0, 0, 0, .15);
  }
  
  .bi {
    vertical-align: -.125em;
    pointer-events: none;
    fill: currentColor;
  }
  
  .dropdown-toggle { outline: 0; }
  
  .nav-flush .nav-link {
    border-radius: 0;
  }
  
  .btn-toggle {
    display: inline-flex;
    align-items: center;
    padding: .25rem .5rem;
    font-weight: 600;
    color: rgba(0, 0, 0, .65);
    background-color: transparent;
    border: 0;
  }
  .btn-toggle:hover,
  .btn-toggle:focus {
    color: rgba(0, 0, 0, .85);
    background-color: #d2f4ea;
  }
  
  .btn-toggle::before {
    width: 1.25em;
    line-height: 0;
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    transition: transform .35s ease;
    transform-origin: .5em 50%;
  }
  
  .btn-toggle[aria-expanded="true"] {
    color: rgba(0, 0, 0, .85);
  }
  .btn-toggle[aria-expanded="true"]::before {
    transform: rotate(90deg);
  }
  
  .btn-toggle-nav a {
    display: inline-flex;
    padding: .1875rem .5rem;
    margin-top: .125rem;
    margin-left: 1.25rem;
    text-decoration: none;
  }
  .btn-toggle-nav a:hover,
  .btn-toggle-nav a:focus {
    background-color: #d2f4ea;
  }
  
  .scrollarea {
    overflow-y: auto;
  }
  
  .fw-semibold { font-weight: 600; }
  .lh-tight { line-height: 1.25; }

  /* SocialMediaIcons.css */
.social-media-container {
  display: flex;
}

.social-media-icon {
  color: #000; /* Default color for all icons */
  font-size: 24px; /* Default size for all icons */
  margin-right: 10px;
}

.facebook-icon {
  color: #1877f2; /* Custom color for Facebook */
}

.twitter-icon {
  color: #1da1f2; /* Custom color for Twitter */
}

.instagram-icon {
  color: #c13584; /* Custom color for Instagram */
}

.tiktok-icon {
  color: #000000; /* Custom color for TikTok */
}

.youtube-icon {
  color: #ff0000; /* Custom color for YouTube */
}
.active a
{
background-color:#ff0000;
}

.text-dark {
  color: #343a40;
}

/* for footer */
html, body, #root {
  height: 100%;
  margin: 0;
  padding: 0;
}

#root {
  display: flex;
  flex-direction: column;
}

footer {
  margin-top: auto;
}

a {

  color: #000;
  text-decoration: none;
}

.rotated-div {
  width: 500px;
  height: 500px;
  background-color: #E5E4E2; 
  opacity: 0.5; 
  transform: rotate(-45deg); 
  transform-origin: top left; 
  position: fixed;
  top: 50%; 
  left: 50%; 
  margin-top: 50px; 
  margin-left: -320px;
  pointer-events: none; 
}
`, "",{"version":3,"sources":["webpack://./src/layouts/style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,mCAAmC;IACnC,gCAAgC;IAChC,mBAAmB;IACnB,wFAAwF;EAC1F;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA,mBAAmB,UAAU,EAAE;;EAE/B;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,6BAA6B;IAC7B,SAAS;EACX;EACA;;IAEE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,cAAc;IACd,gDAAyQ;IACzQ,+BAA+B;IAC/B,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA,eAAe,gBAAgB,EAAE;EACjC,YAAY,iBAAiB,EAAE;;EAE/B,yBAAyB;AAC3B;EACE,aAAa;AACf;;AAEA;EACE,WAAW,EAAE,gCAAgC;EAC7C,eAAe,EAAE,+BAA+B;EAChD,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,8BAA8B;AAChD;;AAEA;EACE,cAAc,EAAE,6BAA6B;AAC/C;;AAEA;EACE,cAAc,EAAE,+BAA+B;AACjD;;AAEA;EACE,cAAc,EAAE,4BAA4B;AAC9C;;AAEA;EACE,cAAc,EAAE,6BAA6B;AAC/C;AACA;;AAEA,wBAAwB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":["body {\r\n    min-height: 100vh;\r\n    min-height: -webkit-fill-available;\r\n  }\r\n  \r\n  html {\r\n    height: -webkit-fill-available;\r\n  }\r\n  \r\n  main {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    height: 100vh;\r\n    height: -webkit-fill-available;\r\n    max-height: 100vh;\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n  }\r\n  \r\n  .b-example-divider {\r\n    flex-shrink: 0;\r\n    width: 1.5rem;\r\n    height: 100vh;\r\n    background-color: rgba(0, 0, 0, .1);\r\n    border: solid rgba(0, 0, 0, .15);\r\n    border-width: 1px 0;\r\n    box-shadow: inset 0 .5em 1.5em rgba(0, 0, 0, .1), inset 0 .125em .5em rgba(0, 0, 0, .15);\r\n  }\r\n  \r\n  .bi {\r\n    vertical-align: -.125em;\r\n    pointer-events: none;\r\n    fill: currentColor;\r\n  }\r\n  \r\n  .dropdown-toggle { outline: 0; }\r\n  \r\n  .nav-flush .nav-link {\r\n    border-radius: 0;\r\n  }\r\n  \r\n  .btn-toggle {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    padding: .25rem .5rem;\r\n    font-weight: 600;\r\n    color: rgba(0, 0, 0, .65);\r\n    background-color: transparent;\r\n    border: 0;\r\n  }\r\n  .btn-toggle:hover,\r\n  .btn-toggle:focus {\r\n    color: rgba(0, 0, 0, .85);\r\n    background-color: #d2f4ea;\r\n  }\r\n  \r\n  .btn-toggle::before {\r\n    width: 1.25em;\r\n    line-height: 0;\r\n    content: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='rgba%280,0,0,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e\");\r\n    transition: transform .35s ease;\r\n    transform-origin: .5em 50%;\r\n  }\r\n  \r\n  .btn-toggle[aria-expanded=\"true\"] {\r\n    color: rgba(0, 0, 0, .85);\r\n  }\r\n  .btn-toggle[aria-expanded=\"true\"]::before {\r\n    transform: rotate(90deg);\r\n  }\r\n  \r\n  .btn-toggle-nav a {\r\n    display: inline-flex;\r\n    padding: .1875rem .5rem;\r\n    margin-top: .125rem;\r\n    margin-left: 1.25rem;\r\n    text-decoration: none;\r\n  }\r\n  .btn-toggle-nav a:hover,\r\n  .btn-toggle-nav a:focus {\r\n    background-color: #d2f4ea;\r\n  }\r\n  \r\n  .scrollarea {\r\n    overflow-y: auto;\r\n  }\r\n  \r\n  .fw-semibold { font-weight: 600; }\r\n  .lh-tight { line-height: 1.25; }\r\n\r\n  /* SocialMediaIcons.css */\r\n.social-media-container {\r\n  display: flex;\r\n}\r\n\r\n.social-media-icon {\r\n  color: #000; /* Default color for all icons */\r\n  font-size: 24px; /* Default size for all icons */\r\n  margin-right: 10px;\r\n}\r\n\r\n.facebook-icon {\r\n  color: #1877f2; /* Custom color for Facebook */\r\n}\r\n\r\n.twitter-icon {\r\n  color: #1da1f2; /* Custom color for Twitter */\r\n}\r\n\r\n.instagram-icon {\r\n  color: #c13584; /* Custom color for Instagram */\r\n}\r\n\r\n.tiktok-icon {\r\n  color: #000000; /* Custom color for TikTok */\r\n}\r\n\r\n.youtube-icon {\r\n  color: #ff0000; /* Custom color for YouTube */\r\n}\r\n.active a\r\n{\r\nbackground-color:#ff0000;\r\n}\r\n\r\n.text-dark {\r\n  color: #343a40;\r\n}\r\n\r\n/* for footer */\r\nhtml, body, #root {\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n#root {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\nfooter {\r\n  margin-top: auto;\r\n}\r\n\r\na {\r\n\r\n  color: #000;\r\n  text-decoration: none;\r\n}\r\n\r\n.rotated-div {\r\n  width: 500px;\r\n  height: 500px;\r\n  background-color: #E5E4E2; \r\n  opacity: 0.5; \r\n  transform: rotate(-45deg); \r\n  transform-origin: top left; \r\n  position: fixed;\r\n  top: 50%; \r\n  left: 50%; \r\n  margin-top: 50px; \r\n  margin-left: -320px;\r\n  pointer-events: none; \r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
